

function PDFPage6Table2(props: any) {
    return (
        <>
        <div>
            <h3 className="cu-fs-18">{props.TranslateString('Breakdown of value estimation for HC\'s apartments, business spaces and car spaces')}</h3>
            <table className="table table-sm table-bordered cu-table-border table-striped cu-fs-10">
                <thead>
                    <tr className="cu-bg-green">
                        <th className="text-nowrap fw-600">{props.TranslateString('Build year of property')}</th>
                        <th className="text-nowrap fw-600">{props.TranslateString('Filtered build years')}</th>
                        <th className="text-nowrap fw-600">{props.TranslateString('Property type')}</th>
                        <th className="text-nowrap fw-600">{props.TranslateString('Land ownership')}</th>
                        <th className="text-nowrap fw-600">{props.TranslateString('Address ')}</th>
                        <th className="text-nowrap fw-600">{props.TranslateString('zip')}</th>
                        <th className="text-nowrap fw-600">{props.TranslateString('city')}</th>
                        {/* <th className="text-nowrap fw-600">{props.TranslateString('region')}</th> */}
                        <th className="text-nowrap fw-600">{props.TranslateString('Sales period')}</th>
                    </tr>
                </thead>
                <tbody className="bg-light">
                    <tr>
                        <td>{props?.ltvDetails?.customer_data?.cust_data_buildyear || ""}</td>
                        <td className="text-nowrap">{(props?.ltvDetails?.customer_data?.start_buildyear || "")+"-"+(props?.ltvDetails?.customer_data?.end_buildyear || "")}</td>
                        <td>{props?.ltvDetails?.customer_data?.filter_property_type.split(",").join(", ").toString() || ""}</td>
                        <td>{props?.ltvDetails?.customer_data?.filter_ownership_type.split(",").join(", ").toString() || ""}</td>
                        <td>{props?.ltvDetails?.customer_data?.cust_data_address || ""}</td>
                        <td>{props?.ltvDetails?.customer_data?.cust_data_zipcode || ""}</td>
                        <td>{props?.ltvDetails?.customer_data?.cust_data_city || ""}</td>
                        {/* <td>{props?.ltvDetails?.customer_data?.cust_data_region || ""}</td> */}
                        <td>{props.TranslateString('Last')} {props?.ltvDetails?.customer_data?.sale_months || ""} {props.TranslateString('Months')}</td>
                    </tr>
                </tbody>
            </table>
            </div>
        </>
    );
}

export default PDFPage6Table2;